export default "__VITE_ASSET__DgGCbgF4__"